( function () {
	'use strict';

	function autoSave ( $document, _ ) {
		function rubricWrapper ( res ) {
			delete res.selected;
			return res;
		}

		function indicatorMapper ( indicator ) {
			return indicator;
		}

		function groupMapper ( group ) {
			delete group.score;

			// stop watching rubric changes
			group.rubric = ( group.rubric || [] ).map( rubricWrapper );
			// stop watching indicators score changes
			group.indicators = ( group.indicators || [] ).map( indicatorMapper );
			return group;
		}

		function removeWatchAttr ( model ) {
			model.template = model.template || {};

			// stop watching rubric changes
			model.template.rubric = ( model.template.rubric || [] ).map( rubricWrapper );
			// stop watching groups score changes
			model.template.groups = ( model.template.groups || [] ).map( groupMapper );
			delete model.score;
			delete model.digitalSignature;
			delete model.masterPrescribedResources;

			return model;
		}

		function link ( $scope, $emelent, $attrs ) {
			function saveModel ( newModel, oldModel ) {
				var model1 = removeWatchAttr( angular.copy( newModel ) );
				var model2 = removeWatchAttr( angular.copy( oldModel ) );

				if ( !angular.equals( model1, model2 ) && model2 !== undefined && _.keys( model2 ).length !== 0 && $scope.vm ) {
					$scope.vm.updateObs();
				}
			}

			$scope.$watch( $attrs.model, saveModel, true );
		}

		return {
			'link'     : link,
			'restrict' : 'A'
		};
	}

	angular
		.module( 'app.components' )
		.run( autoSave )
		.directive( 'autoSave', autoSave );

	autoSave.$inject = [ '$document', '_' ];
} )( );
